<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div class="form-row">
    <label class="col-sm-4 col-form-label" for="personenTyp">{{
      'COMMON_UI.FRAGEBOGEN.STEUERLICHEBERATUNG.PERSONENTYP_TITEL' | translate }}</label>
    <div class="col-sm-8">
      <select class="form-control" formControlName="personenTyp" id="personenTyp" utilsMarkRequired>
        <option *ngIf="requiredSteuerberater" [ngValue]="null" selected>{{
          'COMMON_UI.FRAGEBOGEN.STEUERLICHEBERATUNG.PERSONENTYP.BITTE_WAEHLEN' | translate }}</option>
        <option *ngIf="!requiredSteuerberater" [ngValue]="null" selected>{{
          'COMMON_UI.FRAGEBOGEN.STEUERLICHEBERATUNG.PERSONENTYP.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(personenTypEnum)"
                [ngValue]="personenTypEnum[value]"
                [selected]="data.personenTyp === personenTypEnum[value]">
          {{'COMMON_UI.FRAGEBOGEN.STEUERLICHEBERATUNG.PERSONENTYP.KEY_' + personenTypEnum[value].toUpperCase() | translate }}
        </option>
      </select>
    </div>
  </div>
</form>
